import { render, staticRenderFns } from "./FundraisingGoalCard.vue?vue&type=template&id=dce50f98&scoped=true&"
import script from "./FundraisingGoalCard.vue?vue&type=script&lang=ts&"
export * from "./FundraisingGoalCard.vue?vue&type=script&lang=ts&"
import style0 from "./FundraisingGoalCard.vue?vue&type=style&index=0&id=dce50f98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce50f98",
  null
  
)

export default component.exports